var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","tag":"section"}},[_c('v-row',[_c('z-fund-account-select',{attrs:{"multiple":"false","label":_vm.$i18n.t('Fund Account Select')},model:{value:(_vm.account),callback:function ($$v) {_vm.account=$$v},expression:"account"}})],1),_c('v-row',[_vm._v(_vm._s(_vm.account))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }